<div class="header">
    <span> Quotation</span>
    <span class="desc">Create, Review and Send Quote seamlessly.</span>
</div>
<button matTooltip="Download Quote" matTooltipPosition="left" class="editRequest downloadQuoteBtn" mat-icon-button
    *ngIf="requestService.selectedRequest?.status?.dev_name!='accepted_by_internal_user' && requestService.selectedRequest?.status?.dev_name!='received'"
    (click)="downloadQuote(oneWayQuoteTableService.baseQuote)">
    <i class="flaticon-download"></i>
</button>

<ng-container>
    <div class="container">
        <div class="labelSet" fxFlex="30">
            <span class="titleL">Commercials</span>
            <span class="label">Quantity*</span>
            <span class="label">Condition*</span>
            <span class="label">Pick-up Locations*</span>
            <span class="label">Drop-off Locations*</span>
            <span class="label">PUC* <i
                    matTooltip="This represents the cost associated with picking up each container. It indicates the fee applied per container."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Payee* <i
                    matTooltip="The entity responsible for covering the charges. This can be either ARCON or USER, specifying who is accountable for the payment associated with the deal."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Free Days*</span>
            <span class="label">Per Diem Charge* <i
                    matTooltip="Refers to the daily rental charges incurred beyond the allocated free days. This term specifies the cost applied for each day of rental until containers are returned."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">DPP* <i
                    matTooltip="This refers to a coverage plan for picked up containers, providing protection against potential damages. The DPP ensures financial security by offering coverage for any incurred damages during the container pickup process."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Storage charge* <i
                    matTooltip="The fee assessed for storing each container in the event that containers are not picked up within the designated timeframe."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">New Build Price*</span>
            <span class="label">Depreciation* <i
                    matTooltip="Provide information about the yearly depreciation rate used to calculate the decreased value of containers over time. This can help lessees understand the potential value of their leased assets."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Discounted Residual Value* <i
                    matTooltip="Set a maximum depreciation value beyond which containers should be replaced or undergo significant maintenance or refurbishment."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Max usage days*</span>
            <span class="label">Per Diem post Max usage Days*</span>
            <span class="label">Drop-off charge</span>
            <span class="label">Cancellation charge* <i
                    matTooltip=" The fees imposed per container in the event that containers are not picked up or a deal is canceled."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Quotation valid till*</span>
            <span class="label">Quote Remarks</span>
            <span class="label addAdHoc" *ngIf="nonConsolidatedQuoteCharges.length != 0"
                (click)="addQuoteItemCharge(oneWayQuoteTableService.baseQuote.quote_items)"
                  matTooltip="Add Additional Charge" matTooltipPosition="right" matTooltipHideDelay="2000"> Additional Charges
                +
                <!-- <button mat-icon-button class=" addBtn " > +
                    </button> -->
            </span>
            <ng-container *ngIf="oneWayQuoteTableService?.baseQuote?.quote_items[0].ad_hoc_charges?.length > 0">
                <span *ngIf="nonConsolidatedQuoteCharges.length != 0" style="padding: 5px 0 0 0;">
                    <div class="valueSet">
                        <ng-container
                            *ngFor="let quote of oneWayQuoteTableService.baseQuote.quote_items; let i = index">
                            <ng-container *ngIf="i == 0">
                                <div class="gap-2 align-items-center"
                                    *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                    <app-mat-auto-search [isEditable]="true" [(ngModel)]="charge.quote_charge"
                                        [placeholder]="'Charge Type*'" fxFlex="14em" fxLayout="column" [idField]="null"
                                        [name]="'charge'+i" [options]="nonConsolidatedQuoteCharges" [trim]="true"
                                        [searchable]="true" [labelItemTemplate]="userSelectedItem"
                                        [itemTemplate]="userItem"
                                        class="align-items-center labelInput"></app-mat-auto-search>
                                    <i class="flaticon-delete"
                                        (click)="removeQuoteItemCharge(oneWayQuoteTableService.baseQuote.quote_items, i)"
                                        matTooltip="Delete" matTooltipPosition="below" matTooltipHideDelay="2000"></i>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </span>
            </ng-container>
        </div>
        <div fxFlex="67" class="valueSetBox">
            <div class="valueSet" fxFlex="14em"
                *ngFor="let quote of oneWayQuoteTableService.baseQuote?.quote_items | orderRequirements: 'container_size_type':'display':'asc'; let i = index">
                <span class="valueSetTitle">{{ quote.container_size_type?.display }}</span>
                <app-number-field [isEditable]="negotiate" [placeholder]="'Quantity'" class="w-100i"
                    [(ngModel)]="quote.quantity" [containerNum]="true" [noDecimal]="true" [maxlength]="4"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].quantity" [minValue]="1">
                </app-number-field>
                <app-mat-auto-search [isEditable]="negotiate" [displayField]="'value'" [name]="'container_condition'"
                    [(ngModel)]="quote.container_condition" [idField]="null" [listUrl]="containerConditionLists"
                    [setSearchValue]="false" class="w-100i"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].container_condition">
                </app-mat-auto-search>
                <app-mat-auto-search [(ngModel)]="quote.pol_list"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].pol_list"
                    [isEditable]="negotiate" [idField]="null" displayField='name_display' [trim]="true"
                    [multiple]="true" [defaultChip]="false" [clearable]="true" [closeOnSelect]="false"
                    [clearSearchOnAdd]="true" [listUrl]="location_url" [name]="'pols'" fxLayout="column"
                    class="w-100i locations">
                </app-mat-auto-search>
                <app-mat-auto-search [(ngModel)]="quote.pod_list"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].pod_list"
                    [isEditable]="negotiate" [idField]="null" displayField='name_display' [trim]="true"
                    [multiple]="true" [defaultChip]="false" [clearable]="true" [closeOnSelect]="false"
                    [clearSearchOnAdd]="true" [listUrl]="location_url" [name]="'pods'" fxLayout="column"
                    class="w-100i locations">
                </app-mat-auto-search>
                <logzy-money-field [isEditable]="negotiate" [minValue]="0" [(amount)]="quote.pickup_charge"
                    [(currencyCode)]="quote.pickup_charge_currency" [maxlength]="10"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].pickup_charge" class="w-100i">
                </logzy-money-field>
                <div style="flex: 1 1 100%; max-height: 45px; min-height:45px; padding-top:4px">
                    <mat-button-toggle-group name="Payee" [(ngModel)]="oneWayQuoteTableService.baseQuote.payee"
                        [disabled]="!negotiate">
                        <mat-button-toggle value="arcon">ARCON Pays</mat-button-toggle>
                        <mat-button-toggle value="customer"
                            *ngIf="requestService.selectedRequest.transaction_type=='use'">USER
                            Pays
                        </mat-button-toggle>
                        <mat-button-toggle value="supplier"
                            *ngIf="requestService.selectedRequest.transaction_type=='supply'">SUPPLIER
                            Pays
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <app-number-field [isEditable]="negotiate" [(ngModel)]="quote.min_free_days" [minValue]="0"
                    [maxlength]="3" [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].min_free_days"
                    [noDecimal]="true" class="w-100i">
                </app-number-field>

                <logzy-money-field [isEditable]="negotiate" [(amount)]="quote.min_per_diem"
                    [(currencyCode)]="quote.min_per_diem_currency" [minValue]="0" [maxlength]="6"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].min_per_diem" class="w-100i">
                </logzy-money-field>

                <logzy-money-field [isEditable]="negotiate" [(amount)]="quote.dpp_charge"
                    [(currencyCode)]="quote.dpp_charge_currency" [minValue]="0" [maxlength]="10"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].dpp_charge" class="w-100i">
                </logzy-money-field>

                <logzy-money-field [isEditable]="negotiate" [minValue]="0" [(amount)]="quote.storage_charge"
                    [(currencyCode)]="quote.storage_charge_currency" [maxlength]="10"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].storage_charge" class="w-100i">
                </logzy-money-field>

                <logzy-money-field [isEditable]="negotiate" [placeholder]="'New Build Price'"
                    [(amount)]="quote.drv_new_build_price" [(currencyCode)]="quote.drv_new_build_price_currency"
                    [minValue]="0" [maxlength]="10"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].drv_new_build_price"
                    class="w-100i">
                </logzy-money-field>

                <app-percent-field [isEditable]="negotiate" [placeholder]="'Depreciation'"
                    [(ngModel)]="quote.drv_depreciation_per_year" fxLayout="column" class="w-100i"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].drv_depreciation_per_year">
                </app-percent-field>

                <!-- here to add new field -->
                <logzy-multi-field [isEditable]="negotiate" [placeholder]="'Discounted Residual Value'"
                    [(amount)]="quote.drv_max_depreciation_price"
                    [(currencyCode)]="quote.drv_max_depreciation_price_currency"
                    [(percent)]="quote.drv_max_depreciation_percent" [selectField]="quote.drv_max_depreciation_unit"
                    (selectFieldChange)="selectChoice($event,i)" fxLayout="column" class="w-100i"
                    [(errors)]="quote.drv_max_depreciation_unit == 'price' ? oneWayQuoteTableService.baseQuote.error.quote_items[i].drv_max_depreciation_price : oneWayQuoteTableService.baseQuote.error.quote_items[i].drv_max_depreciation_percent">
                </logzy-multi-field>
                <!-- <app-percent-field [isEditable]="negotiate" [placeholder]="'Max Depreciation'"
                    [(ngModel)]="quote.drv_max_depreciation_percent" fxLayout="column" class="w-100i"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].drv_max_depreciation_percent">
                </app-percent-field> -->

                <app-number-field [isEditable]="negotiate" [(ngModel)]="quote.max_free_days" [minValue]="0"
                    [maxlength]="3" [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].max_free_days"
                    [noDecimal]="true" class="w-100i">
                </app-number-field>

                <logzy-money-field [isEditable]="negotiate" [(amount)]="quote.max_per_diem"
                    [(currencyCode)]="quote.max_per_diem_currency" [minValue]="0" [maxlength]="6"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].max_per_diem" class="w-100i">
                </logzy-money-field>

                <logzy-money-field [isEditable]="negotiate" [minValue]="0" [(amount)]="quote.dropoff_charge"
                    [(currencyCode)]="quote.dropoff_charge_currency" [maxlength]="10"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].dropoff_charge" class="w-100i">
                </logzy-money-field>

                <logzy-money-field [isEditable]="negotiate" [(amount)]="quote.cancellation_charge"
                    [(currencyCode)]="quote.cancellation_charge_currency" [minValue]="0" [maxlength]="10"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_items[i].cancellation_charge"
                    class="w-100i">
                </logzy-money-field>

                <app-date-field [isEditable]="negotiate"
                    [(ngModel)]="oneWayQuoteTableService.baseQuote.quote_valid_till" [class.hidden]="i!=0"
                    [disabled]="i!=0" [(errors)]="oneWayQuoteTableService.baseQuote.error.quote_valid_till"
                    [minDate]="currentDate" class="w-100i" fxLayout="column">
                </app-date-field>

                <app-text-field [isEditable]="negotiate" [isMultiline]="true" [class.hidden]="i!=0" [disabled]="i!=0"
                    class="w-100i" fxLayout="column" [(ngModel)]="oneWayQuoteTableService.baseQuote.remarks"
                    [name]="'remarks'" [(errors)]="oneWayQuoteTableService.baseQuote.error.remarks">
                </app-text-field>
                <span style="height: 45px;"> &nbsp; </span>
                <ng-container *ngIf="nonConsolidatedQuoteCharges.length != 0">
                    <div class=" rGap15 inputs leaseRequest">
                        <ng-container *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                            <logzy-money-field [isEditable]="true" [(amount)]="charge.amount" fxFlex="100"
                                fxLayout="column" [maxValue]="999999999" [(currencyCode)]="charge.amount_currency"
                                [(errors)]="charge?.error.amount">
                            </logzy-money-field>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="consolidatedQuoteCharges.length != 0">
    <div class="vstack " [class.gap-2]="tncExpand">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor">
                Request Quote Charges
            </span>
        </div>
        <div class="additionalDetails" style="justify-content: flex-end;" [class.viewExpand]="tncExpand">
            <button mat-raised-button class="clickIt addBtn addReq" [disabled]="!negotiate" (click)="addCharge()"
                    matTooltip="Add new Additional Charge" matTooltipPosition="left" matTooltipHideDelay="2000">+
                Additional Charges
            </button>
            <div fxFlex="100" class="inputs">
                <div fxFlex="100" class="leaseRequest leasebox">
                    <!-- <div class="leasebox"> -->
                    <div class="inputs"
                        *ngFor="let charge of oneWayQuoteTableService.baseQuote.ad_hoc_charges, let i=index">
                        <div fxFlex="15em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Charge Type*</span>
                            </div>
                            <app-mat-auto-search [isEditable]="true" fxFlex="100" [(ngModel)]="charge.quote_charge"
                                [idField]="null" [name]="'charge'+i" [options]="consolidatedQuoteCharges" [trim]="true"
                                [searchable]="true" [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem"
                                class="align-items-center"
                                [(errors)]="charge?.error.quote_charge"></app-mat-auto-search>
                        </div>
                        <div fxFlex="15em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Amount*</span>
                            </div>
                            <div fxFlex="100">
                                <logzy-money-field [isEditable]="true" [(amount)]="charge.amount" [maxValue]="999999999"
                                    [(currencyCode)]="charge.amount_currency" [(errors)]="charge?.error.amount">
                                </logzy-money-field>
                            </div>
                        </div>
                        <div class="actionBtn">
                            <i class="flaticon-delete" (click)="removeCharge(i)" matTooltip="Delete"
                                matTooltipPosition="below" matTooltipHideDelay="2000"
                                *ngIf="oneWayQuoteTableService.baseQuote.ad_hoc_charges.length > 0"></i>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container>
    <div class="vstack " [class.gap-2]="insuranceExpand">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor" (click)="insuranceExpand = !insuranceExpand"> Insurance*
                <i class="flaticon-down-chevron" [ngClass]="insuranceExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="matView w131" [class.viewExpand1]="insuranceExpand">
            <!-- <span class="title">Insurance*</span> -->
            <!-- [disabled]="!negotiate"  //Between Mat radio Card// -->
            <!-- (onDataChange)="updateInsurance($event)" [insurance]="oneWayQuoteTableService.baseQuote.insurance" -->
            <mat-radio-card class="cardHolder" [insList]="insuranceList?.results" [disabled]="!negotiate"
                [ngModel]="oneWayQuoteTableService.baseQuote.insurance" (ngModelChange)="setInsurance($event)"
                [name]="'insurance'" [(errors)]="oneWayQuoteTableService.baseQuote?.error.insurance">
            </mat-radio-card>
            <div class="selectedInsurance">
                <span><b>Selected Insurance:</b> {{oneWayQuoteTableService.baseQuote.insurance?.name}}</span>
                <logzy-money-field
                    [isEditable]="negotiate && !isCustomer && oneWayQuoteTableService.baseQuote.insurance?.amount==null"
                    [amount]="oneWayQuoteTableService.baseQuote.insurance_premium"
                    [(currencyCode)]="oneWayQuoteTableService.baseQuote.insurance_premium_currency" [minValue]="0"
                    [class.clickIt]="getDataInsurance && !isCustomer && oneWayQuoteTableService.baseQuote.insurance?.amount==null"
                    [(errors)]="oneWayQuoteTableService.baseQuote.error.insurance_premium"
                    (amountChange)="setInsuranceAmount($event)" fxFlex="12em">
                </logzy-money-field>
            </div>
        </div>
    </div>
</ng-container>
<ng-container>
    <div class="vstack " [class.gap-2]="tncExpand">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor">
                Terms and Conditions
            </span>
        </div>
        <div class="additionalDetails " [class.viewExpand]="tncExpand">
            <app-select-field [isEditable]="!isCustomer && negotiate"
                [hidden]="isCustomer || oneWayQuoteTableService.termsConditionList?.length == 1"
                [name]="'termsCondition'" [displayField]="'name'"
                [(ngModel)]="oneWayQuoteTableService.termsAndCondition"
                [options]="oneWayQuoteTableService.termsConditionList" fxLayout="column" fxFlex="12em"
                (ngModelChange)="setTermsConditions()"
                [errors]="oneWayQuoteTableService.baseQuote.error.terms_and_condition_fk">
            </app-select-field>
            <quill-editor *ngIf="!isCustomer" [styles]="{'min-height': '50px'}"
                [(ngModel)]="oneWayQuoteTableService.selectedTermsAndCondition" id="termsAndCondition"
                [modules]="modules" #editor placeholder="Enter Terms and Conditions ....." style="width: inherit;">
            </quill-editor>
            <quill-view *ngIf="isCustomer" [content]="oneWayQuoteTableService.selectedTermsAndCondition" format="html"
                theme="snow" style="max-width: 761px;   overflow: auto;"></quill-view>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="requestService.selectedRequest.status.dev_name!='quote_accepted_by_external_user'">
    <div fxFlex="100" class="btnb" fxLayout="row wrap">
        <button *ngIf="isCustomer" class="loadingBtn Save" mat-raised-button
            [disabled]="oneWayQuoteTableService.disableSaveButton || !negotiate" (click)="cancelQuoteEditing()">
            <span>Cancel</span>
        </button>
        <button *ngIf="!isCustomer" class="loadingBtn Save" mat-raised-button
            (click)="reviewQuote(oneWayQuoteTableService.baseQuote, false)">
            <span>Review Quote</span>
        </button>
        <button class="loadingBtn Save" mat-raised-button
            [disabled]="oneWayQuoteTableService.disableSaveButton || !negotiate" (click)="saveQuote()">
            <span *ngIf="!oneWayQuoteTableService.disableSaveButton">
                {{isCustomer ? 'Save Negotiation' : 'Save Quotation'}}
            </span>
            <div *ngIf="oneWayQuoteTableService.disableSaveButton" class="p03">
                <i class="flaticon-loading spin"></i>
                <span>Saving...</span>
            </div>
        </button>
    </div>
</ng-container>
<ng-container *ngIf="requestService.selectedRequest.status.dev_name=='quote_accepted_by_external_user'">
    <div fxFlex="100" class="btnb" fxLayout="row wrap">
        <button *ngIf="!isCustomer" class="loadingBtn Save" mat-raised-button
            (click)="reviewQuote(oneWayQuoteTableService.baseQuote, true)">
            <span>Create Booking</span>
        </button>
    </div>
</ng-container>
<ng-container>
    <div class="vstack " [class.gap-2]="uploadDocExpand">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor" (click)="uploadDocExpand = !uploadDocExpand">
                Comments/Attachments
                <i class="flaticon-down-chevron" [ngClass]="uploadDocExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="additionalDetails" [class.viewExpand]="uploadDocExpand">
            <mat-tab-group animationDuration="1500ms">
                <mat-tab label="Comments">
                    <logzy-quote-remarks fxLayout="row wrap">
                    </logzy-quote-remarks>
                </mat-tab>
                <mat-tab label="Attachments">
                    <logzy-request-documents fxFlex="100"></logzy-request-documents>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</ng-container>

<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.charge?.print_name}}
        </span>
        <span class="email">
            {{item?.charge?.charge_code}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item?.charge?.print_name}}
</ng-template>
